// premier league team logos
const teamLogos = {
  "Arsenal":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Arsenal_FC.svg",
  "Arsenal FC":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Arsenal_FC.svg",

  "Aston Villa":
    "https://fr.wikipedia.org/wiki/Special:Redirect/file/Logo_Aston_Villa.svg",
  "Aston Villa FC":
    "https://fr.wikipedia.org/wiki/Special:Redirect/file/Logo_Aston_Villa.svg",

  "Bournemouth":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/AFC_Bournemouth_(2013).svg",
  "AFC Bournemouth":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/AFC_Bournemouth_(2013).svg",
  "Bournemouth FC":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/AFC_Bournemouth_(2013).svg",

  "Brentford":
    "https://fr.wikipedia.org/wiki/Special:Redirect/file/Brentford_FC_logo.svg",
  "Brentford FC":
    "https://fr.wikipedia.org/wiki/Special:Redirect/file/Brentford_FC_logo.svg",

  "Brighton Hove Albion":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Brighton_%26_Hove_Albion_logo.svg",
  "Brighton & Hove Albion":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Brighton_%26_Hove_Albion_logo.svg",
  "Brighton & Hove Albion FC":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Brighton_%26_Hove_Albion_logo.svg",

  "Burnley":
    "https://en.wikipedia.org/wiki/Special:Redirect/file/Burnley_FC_Logo.svg",
  "Burnley FC":
    "https://en.wikipedia.org/wiki/Special:Redirect/file/Burnley_FC_Logo.svg",

  "Chelsea":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Chelsea_FC.svg",
  "Chelsea FC":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Chelsea_FC.svg",

  "Crystal Palace":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Crystal_Palace_FC_logo.svg",
  "Crystal Palace FC":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Crystal_Palace_FC_logo.svg",

  "Everton":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Everton_FC_logo.svg",
  "Everton FC":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Everton_FC_logo.svg",

  "Fulham":
    "https://en.wikipedia.org/wiki/Special:Redirect/file/Fulham_FC_(shield).svg",
  "Fulham FC":
    "https://en.wikipedia.org/wiki/Special:Redirect/file/Fulham_FC_(shield).svg",

  "Leeds United":
    "https://fr.wikipedia.org/wiki/Special:Redirect/file/Logo_Leeds_United_FC.svg",
  "Leeds United FC":
    "https://fr.wikipedia.org/wiki/Special:Redirect/file/Logo_Leeds_United_FC.svg",

  "Liverpool":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Liverpool_FC.svg",
  "Liverpool FC":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Liverpool_FC.svg",

  "Manchester City":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Manchester_City_FC_badge.svg",
  "Manchester City FC":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Manchester_City_FC_badge.svg",

  "Manchester United":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Manchester_United_FC_crest.svg",
  "Manchester United FC":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Manchester_United_FC_crest.svg",

  "Newcastle United":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Newcastle_United_Logo.svg",
  "Newcastle United FC":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Newcastle_United_Logo.svg",

  "Nottingham Forest":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Nottingham_Forest_logo.svg",
  "Nottingham Forest FC":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Nottingham_Forest_logo.svg",

  "Sunderland":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Logo_Sunderland.svg",
  "Sunderland AFC":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Logo_Sunderland.svg",

  "Tottenham Hotspur":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Tottenham_Hotspur.svg",
  "Tottenham Hotspur FC":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Tottenham_Hotspur.svg",

  "West Ham United":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/West_Ham_United_FC_logo.svg",
  "West Ham United FC":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/West_Ham_United_FC_logo.svg",

  "Wolverhampton Wanderers":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Wolverhampton_Wanderers.svg",
  "Wolverhampton Wanderers FC":
    "https://sco.wikipedia.org/wiki/Special:Redirect/file/Wolverhampton_Wanderers.svg",
};

export default teamLogos;